<!-- App.vue -->
<template>
  <v-app>
    <metainfo></metainfo>
    <HeaderComponent />
    <v-main>
      <router-view />
    </v-main>
    <FooterComponent />
  </v-app>
</template>

<script>
import HeaderComponent from '@/components/HeaderComponent.vue';
import FooterComponent from '@/components/FooterComponent.vue';

// import { useMeta } from 'vue-meta' // import useMeta 

export default {

  
  name: 'App',
  components: {
    HeaderComponent,
    FooterComponent,
  },
};
</script>

<style>
body {
  margin: 0;
  font-family: 'Pretendard', sans-serif;
}
</style>
